import { arrayOf, bool, string } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import { contactListShape } from '../../../prop-types';
import { COLORS } from '../../../utils/constants';

export default function AddToContactListButton({
  disabled,
  list,
  selectedContactIds,
  ...rest
}) {
  const hasAllSelectedContacts = selectedContactIds.every(contactId =>
    list.contactIds.includes(Number(contactId)),
  );
  const buttonLabel = hasAllSelectedContacts ? '✓ Added' : '+ Add to List';
  return (
    <Button
      disabled={disabled || hasAllSelectedContacts}
      color={COLORS.PRIMARY}
      {...rest}
    >
      {buttonLabel}
    </Button>
  );
}

AddToContactListButton.propTypes = {
  list: contactListShape.isRequired,
  disabled: bool,
  selectedContactIds: arrayOf(string.isRequired).isRequired,
};

AddToContactListButton.defaultProps = {
  disabled: false,
};
